import loadImage from './loadImage';
import preloadImages from './preloadImages';
export default {
  loadImage: loadImage,
  preloadImages: preloadImages
};


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/images/index.js
// module id = 1163
// module chunks = 168